<template>
  <section>
    <svg class="logo" width="100%" height="448" viewBox="0 0 1024 448">
      <g
        stroke="#7c5cdb"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
        transform="translate(155 0)"
      >
        <Paths :letter="a" />
        <Paths :letter="l" transform="translate(-124 0)" />
        <Paths :letter="e" transform="translate(-280 0)" />
        <Paths :letter="x" transform="translate(408 240)" />
      </g>
    </svg>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import anime from "animejs/lib/anime.es.js";
import Paths from "./Paths";
import { a, l, e, x } from "../utils/letters";
export default {
  name: "Logo",
  components: {
    Paths,
  },
  data: () => ({
    a: a,
    l: l,
    e: e,
    x: x,
  }),
  methods: {
    ...mapActions(["logoAnimComp"]),
    push() {
      this.$router.push("lets-build");
    },
    animate(direction, duration) {
      const tl = anime.timeline({
        direction: direction,
      });
      tl.add({
        targets: ".line",
        translateX: (target) => {
          let x = 1200;
          let translate;
          if (target.classList.contains("hori"))
            translate = anime.random(0, 1) ? x : -x;
          if (
            target.classList.contains("diag-right") ||
            target.classList.contains("diag-left")
          )
            translate = x / 3;
          return [translate, 0];
        },
        translateY: (target) => {
          let y = 1200;
          let translate;
          if (target.classList.contains("vert"))
            translate = anime.random(0, 1) ? y : -y;
          if (target.classList.contains("diag-right")) translate = -y / 3;
          if (target.classList.contains("diag-left")) translate = y / 3;
          return [translate, 0];
        },
        scale: {
          value: [6, 1],
          duration: 500,
        },
        stroke: "hsl(200, 50%, 50%)",
        opacity: {
          value: [0, 1],
          duration: 100,
        },
        delay: (t, i) => i * 25,
        duration: duration,
        easing: "easeOutQuart",
        offset: 0,
      });

      if (direction === "forward") {
        tl.finished.then(this.logoAnimComp);
      }

      if (direction === "reverse") {
        tl.finished.then(this.push);
      }
    },
  },
  computed: mapGetters(["getLetsBuild"]),
  watch: {
    getLetsBuild() {
      this.animate("reverse", 500);
    },
  },
  mounted() {
    this.animate("forward", 1000);
  },
};
</script>

<style scoped>
section {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: -1;
}
.logo {
  margin: auto;
}
</style>
